var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoverDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2422 4.85254C10.364 4.85255 10.4742 4.90942 10.5615 5.00488C10.6429 5.10685 10.6846 5.23341 10.6729 5.36719C10.6729 5.41139 10.3472 9.79229 10.1611 11.6367C10.0446 12.7684 9.35793 13.4558 8.3291 13.4746C7.53819 13.4935 6.76511 13.5 6.00391 13.5C5.19559 13.5 4.405 13.4935 3.6377 13.4746C2.64334 13.4493 1.95723 12.7496 1.84668 11.6367C1.65529 9.78585 1.33504 5.41139 1.3291 5.36719C1.32324 5.2335 1.36349 5.10682 1.44531 5.00488C1.52614 4.90933 1.64319 4.85254 1.76562 4.85254H10.2422ZM7.26172 0.5C7.80187 0.5 8.28501 0.900818 8.4248 1.47266L8.52441 1.94727C8.60525 2.33404 8.92065 2.6084 9.2832 2.6084H11.0645C11.3021 2.6084 11.4999 2.81791 11.5 3.08496V3.33203C11.5 3.5927 11.3022 3.80957 11.0645 3.80957H0.936523C0.698187 3.80957 0.5 3.5927 0.5 3.33203V3.08496C0.50012 2.81791 0.698259 2.6084 0.936523 2.6084H2.71777C3.07974 2.6084 3.39514 2.33437 3.47656 1.94824L3.57031 1.50488C3.71538 0.901122 4.19215 0.500035 4.73828 0.5H7.26172Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverDeleteIcon);
export default __webpack_public_path__ + "static/media/HoverDeleteIcon.68652c87841ec728d6df04f2810cba8f.svg";
export { ForwardRef as ReactComponent };